import React, { useEffect, useState } from "react";
import Loadding from "../../components/common/loadding";
import ChangePassword from "../../components/profile/changePassword";
import EditUser from "../../components/users/editUser";
import EditUserForAdmin from "../../components/users/editUserForAmin";
import userService from "../../services/user.service";

const Profile = () => {
  const userLocal = JSON.parse(localStorage.getItem("user") ?? "false");
  const [user, serUser] = useState<any>(null);
  const [status, setStatus] = useState(true);
  useEffect(() => {
    (async () => {
      await userService.getId(userLocal.id).then((res) => {
        serUser(res.data);
        setStatus(false);
      });
    })();
  }, [userLocal.id]);

  // console.log(userLocal.role.name);

  if (status) return <Loadding />;
  return (
    <>
      <div className="container">
        <h3 className="text-start mt-3">จัดการ Profile</h3>
        <hr />
        <div className="row">
          <section style={{ backgroundColor: "#eee" }}>
            <div className="container py-5">
              <div className="row">
                <div className="col">
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-sm-3">
                          <p className="mb-0">Username</p>
                        </div>
                        <div className="col-sm-9">
                          <p className="text-muted mb-0">{user.username}</p>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-sm-3">
                          <p className="mb-0">อีเมลล์</p>
                        </div>
                        <div className="col-sm-9">
                          <p className="text-muted mb-0">{user.email}</p>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-sm-3">
                          <p className="mb-0">โทรศัพท์</p>
                        </div>
                        <div className="col-sm-9">
                          <p className="text-muted mb-0">{user.tel}</p>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-sm-3">
                          <p className="mb-0">ชื่อ-สกุล</p>
                        </div>
                        <div className="col-sm-9">
                          <p className="text-muted mb-0">
                            {user.firstName} {user.lastName}
                          </p>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-sm-3">
                          <p className="mb-0">หลักสูตร</p>
                        </div>
                        <div className="col-sm-9">
                          <p className="text-muted mb-0">
                            {user.curriculum.map((curri: any) => {
                              return (
                                <div key={curri.id}>{curri.shortName}</div>
                              );
                            })}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row-">
                <div className="col">
                  {/* {userLocal.role.name === "Guest" ?? */}
                  {userLocal.role.name === "Guest" ? (
                    <></>
                  ) : (
                    <>
                      {userLocal.role.name === "Admin" ? (
                        <EditUserForAdmin user={user} />
                      ) : (
                        <EditUser user={user} />
                      )}
                      <ChangePassword
                        userId={user.id}
                        username={user.username}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Profile;
